import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-12">
          <img
            src="/brand/dreamonds-logo-light.png"
            alt="Dreamonds"
            className="h-11 w-auto mx-auto"
            data-testid="admin-login-logo"
          />
          <p className="label-track text-[#737373] mt-6">Studio Access</p>
        </div>
        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="label-track text-[#737373] block mb-3">Email</label>
            <input
              data-testid="admin-email-input"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="bg-transparent border-b border-[#E5E5E5] focus:border-[#0A0A0A] text-[#0A0A0A] rounded-none px-0 py-2 outline-none w-full transition-colors"
            />
          </div>
          <div>
            <label className="label-track text-[#737373] block mb-3">Password</label>
            <input
              data-testid="admin-password-input"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="bg-transparent border-b border-[#E5E5E5] focus:border-[#0A0A0A] text-[#0A0A0A] rounded-none px-0 py-2 outline-none w-full transition-colors"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-[#B76E79] text-sm">{error}</p>}
          <button
            data-testid="admin-login-submit" type="submit" disabled={busy}
            className="w-full bg-[#0A0A0A] text-white py-4 label-track hover:bg-[#333333] transition-colors disabled:opacity-50"
          >
            {busy ? "Entering…" : "Enter Studio"}
          </button>
        </form>
      </div>
    </div>
  );
}
